import React from 'react';
import { useMediaQuery } from 'react-responsive';

export const SIDE_MENU_WIDE_MIN_WIDTH = 1920;

export const Desktop = ({ children }) => (useMediaQuery({ minWidth: 1400 }) ? children : null);
export const Tablet = ({ children }) => (useMediaQuery({ minWidth: 768, maxWidth: 1399 }) ? children : null);
export const FromTablet = ({ children }) => (useMediaQuery({ minWidth: 768 }) ? children : null);
export const Phone = ({ children }) => (useMediaQuery({ maxWidth: 767 }) ? children : null);
export const NotPhone = ({ children }) => (useMediaQuery({ minWidth: 768 }) ? children : null);
export const PhoneOrTablet = ({ children }) => (useMediaQuery({ maxWidth: 1399 }) ? children : null);
export const Mobile = ({ children }) => (useMediaQuery({ maxWidth: 991 }) ? children : null);

const createWithResponsiveWrapper = (Component) => {
	const WithResponsive = (props) => {
		const isPhone = useMediaQuery({ maxWidth: 767 });
		const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1399 });
		const isWideViewport = useMediaQuery({ minWidth: SIDE_MENU_WIDE_MIN_WIDTH });
		let responsive = 'desktop';
		if (isPhone) {
			responsive = 'phone';
		} else if (isTablet) {
			responsive = 'tablet';
		}
		return <Component {...props} responsive={responsive} isWideViewport={isWideViewport} />;
	};

	WithResponsive.displayName = `withResponsive(${Component.displayName || Component.name || 'Component'})`;
	return WithResponsive;
};

export const withResponsive = (Component, context) => {
	if (context && context.kind !== 'class') {
		return Component;
	}
	return createWithResponsiveWrapper(Component);
};

export const withIsPhone = withResponsive;
